import { Stack } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { BinocularsIcon, DownloadIcon } from "@looksrare/uikit";
import { Button, Text } from "uikit";

export const SearchPrompt = ({
  seedWatchlist,
  isSeedInProgress = false,
}: {
  seedWatchlist: () => void;
  isSeedInProgress?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <Stack spacing={4} alignItems="center" my={8}>
      <BinocularsIcon color="interactive-01" boxSize={16} />
      <Text color="text-02" textAlign="center">
        {t(
          "Search above for collections to add to your watchlist, or automatically add every verified collection in your wallet!"
        )}
      </Text>
      <Button
        isLoading={isSeedInProgress}
        onClick={seedWatchlist}
        leftIcon={<DownloadIcon />}
        data-id="watchlist-add-collections-modal-import-all-collections"
      >
        {t("Import All Collections from Wallet")}
      </Button>
    </Stack>
  );
};
